import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.5 0v16m4-11a3.11 3.11 0 0 0-3.05-2.5H7.156a2.656 2.656 0 0 0-.33 5.29l3.348.42a2.656 2.656 0 0 1-.33 5.29H7.55A3.11 3.11 0 0 1 4.5 11",
  stroke: "#626262"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }